import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { buttonVariants } from '@/components/ui/button-variants';

export default function ForbiddenPage() {
  return (
    <div className="grid min-h-[60dvh] place-items-center text-center">
      <div className="space-y-4">
        <ShieldAlert className="mx-auto h-12 w-12 text-amber-500" />
        <h1 className="text-2xl font-semibold">403 — Out of scope</h1>
        <p className="max-w-md text-sm text-ink-muted">
          Your role does not grant this permission, or this record sits outside the branch,
          floor or area you are assigned to.
        </p>
        <Link to="/" className={buttonVariants()}>
          Back to overview
        </Link>
      </div>
    </div>
  );
}
